// Select options for the waf_free campaign lead form (English, matching the
// console's language). Values are sent to DataCentral as-is.

/** Position (Chức vụ). */
export const POSITION_OPTIONS = [
  'Business owner',
  'C-Level',
  'M-Level',
  'Employee',
  'Other',
] as const;

/** Company size (Quy mô doanh nghiệp). */
export const COMPANY_SIZE_OPTIONS = [
  'Under 50 employees',
  '50 - 199 employees',
  '200 - 999 employees',
  '1000 - 4999 employees',
  'Over 5000 employees',
] as const;

// Purpose of use (Mục đích sử dụng) — SINGLE-select. "Other" reveals a free-text
// input; that text is sent as `specificNeeds`.
export const OTHER_SOLUTION = 'Other';
export const INTERESTED_SOLUTION_OPTIONS = [
  'Protect Web/App/API',
  'Trial / evaluation before purchase',
  'Research / study',
  OTHER_SOLUTION,
] as const;
